import { LoggerLevel } from 'types';

const environmentConfig = {
  environment: 'perf',
  applicationId: 'qa-react-header-footer',
  api: {
    homr: 'https://www.dickssportinggoods.com/dcsg-ngx-home/homr/v2/api/v4/content',
    sayt: {
      dsg: { baseUrl: 'https://api-search.dksxchange.com/' },
      gg: { baseUrl: 'https://api-search.dksxchange.com/' },
      pl: { baseUrl: 'https://api-search.dksxchange.com/' },
      mj: { baseUrl: 'https://api-search.dksxchange.com/' },
      g3: { baseUrl: 'https://api-search.dksxchange.com/' },
    },
    availability: {
      dsg: {
        baseUrl: 'https://availability.dksxchange.com',
        key: 'sb-1dd8664e-1a20-11ec-9eb4-0f41c435f283',
      },
      gg: {
        baseUrl: 'https://availability.dksxchange.com',
        key: 'sb-1dd8664e-1a20-11ec-9eb4-0f41c435f283',
      },
      pl: {
        baseUrl: 'https://availability.dksxchange.com',
        key: 'sb-1dd8664e-1a20-11ec-9eb4-0f41c435f283',
      },
      mj: {
        baseUrl: 'https://availability.dksxchange.com',
        key: 'sb-1dd8664e-1a20-11ec-9eb4-0f41c435f283',
      },
      g3: {
        baseUrl: 'https://availability.dksxchange.com',
        key: 'sb-1dd8664e-1a20-11ec-9eb4-0f41c435f283',
      },
    },
    microService: {
      logger: {
        path: '/spring/msvc/logger/publish',
        host: {
          dsg: {
            baseUrl: 'https://prod-dickssportinggoods.dksxchange.com',
          },
          gg: {
            baseUrl: 'https://prod-golfgalaxy.dksxchange.com',
          },
          pl: {
            baseUrl: 'https://prod-publiclands.dksxchange.com',
          },
          mj: {
            baseUrl: 'https://prod-moosejaw.dksxchange.com',
          },
          g3: {
            baseUrl: 'https://prod-goinggoinggone.dksxchange.com',
          },
        },
      },
    },
    logger: {
      client: {
        level: LoggerLevel.LOG,
      },
      xhr: {
        level: LoggerLevel.LOG, // DO NOT TOUCH
        url: 'https://staging-log-publisher.iso.ap01.pcf.dcsg.com/publish', // same as deploy domain in build.yml
      },
    },
    promotionData: {
      dsg: {
        baseUrl: 'https://gateway.dcsg.com/ws/WCS/v2/api/promotiondescription',
        key: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
        headerEnvValue: 'prdlive',
      },
      gg: {
        baseUrl: 'https://gateway.dcsg.com/ws/WCS/v2/api/promotiondescription',
        key: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
        headerEnvValue: 'prdlive',
      },
      pl: {
        baseUrl: 'https://gateway.dcsg.com/ws/WCS/v2/api/promotiondescription',
        key: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
        headerEnvValue: 'prdlive',
      },
      mj: {
        baseUrl: 'https://gateway.dcsg.com/ws/WCS/v2/api/promotiondescription',
        key: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
        headerEnvValue: 'prdlive',
      },
      g3: {
        baseUrl: 'https://gateway.dcsg.com/ws/WCS/v2/api/promotiondescription',
        key: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
        headerEnvValue: 'prdlive',
      },
    },
  },
};

export default environmentConfig;
